import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import ConfigureTeamCompetitonSection from "../components/TeamCompetitions/ConfigureTeamCompetitonSection";
import Loader from "../components/general/Loader";
import NoData from "../components/general/NoData";
import NunitoText from "../components/general/NunitoText";
import ReusableButton from "../components/general/ReusableButton";
import { showWarningSwal } from "../functions/alert";
import { isAdmin } from "../functions/checkrole";
import { deepCopy, populateCompetition } from "../functions/edit";
import {
  getCollectionsListing,
  getCompetitions,
  getDifficultyGroup,
} from "../functions/getData";

export default function ConfigureTeamCompetition() {
  const [loading, setLoading] = useState(true);
  const [firstLoaded, setFirstLoaded] = useState(false);
  const [original, setOriginal] = useState();
  const [competition, setCompetition] = useState();
  const competitionOptions = [];
  const [collectionOptions, setCollectionOptions] = useState([]);
  // const [competitionOptions, setCompetitionOptions] = useState([])
  // const [tagOptions, setTagOptions] = useState([])
  const [difficultyGroupOptions, setDifficultyGroupOptions] = useState([]);
  document.title = "Configure Team Competition";
  let location = useLocation();
  useEffect(() => {
    const controller = new AbortController();
    const signal = controller.signal;
    if (location.search.slice(0, 4) === "?id=") {
      getCompetitions(`/${location.search.slice(4)}`, signal)
        .then((c) => {
          //   console.log(makeSureIsArray(c).filter(el=>{
          //      console.log(el)
          //    return el.id === Number(location.search.slice(4))
          // })[0])
          let foundCompetition = populateCompetition(c);
          setOriginal(deepCopy(foundCompetition));
          setCompetition(foundCompetition);
          if (isAdmin()) {
            // getCollections("?status=active&limits=200", signal)
            getCollectionsListing(signal)
              .then((c) => {
                //  console.log(c.collectionList.data);
                setCollectionOptions(
                  c.data.map((d) => ({ id: d.id, name: d.name }))
                );
              })
              .catch((e) => console.log(e));
            getDifficultyGroup("?status=active&limits=100", signal)
              .then((d) => {
                setDifficultyGroupOptions(
                  d.TaskDifficultyGroupSLists.data.map((d) => ({
                    id: d.id,
                    name: d.name,
                  }))
                );
              })
              .catch((e) => console.log(e));
          }
        })
        .catch((e) => console.log(e))
        .finally(() => {
          if (!signal.aborted) {
            setLoading(false);
            setFirstLoaded(true);
          }
        });
    } else {
      showWarningSwal("Wrong query");
      if (!signal.aborted) {
        setLoading(false);
        setFirstLoaded(true);
      }
    }
    return () => controller.abort();
  }, [location.search]);
  return (
    <Box className="wrapperBox">
      <div className="firstRowContainer dashboardAndSelfBtnDiv">
        <ReusableButton
          text="Dashboard"
          fontSize={14}
          bgColor="#F16774"
          height={36}
          width={125}
          br={18}
          to="/dashboard"
          iconType="home"
        />
        <ChevronRightIcon />
        <ReusableButton
          text="Team Competitions"
          fontSize={14}
          bgColor="#F16774"
          height={36}
          br={18}
          to="/competitions"
        />
      </div>
      <div className="formContainer">
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            alignItems: "start",
          }}
        >
          <NunitoText
            value={competition?.name}
            fontSize={36}
            fontWeight={600}
            italic
            color="#144A94"
            align="left"
          />
          <NunitoText
            value="Configure 'MMM' Team Competition"
            fontSize={30}
            fontWeight={700}
            italic
            color="#4f4f4f"
            align="left"
          />
        </div>
        {loading ? (
          <Loader height={600} />
        ) : competition ? (
          <ConfigureTeamCompetitonSection
            original={original}
            setOriginal={setOriginal}
            competition={competition}
            setCompetition={setCompetition}
            difficultyGroupOptions={difficultyGroupOptions}
            competitionOptions={competitionOptions}
            collectionOptions={collectionOptions}
          />
        ) : (
          firstLoaded && <NoData height={600} />
        )}
      </div>
    </Box>
  );
}
